import React from 'react';
import { useNavigate } from 'react-router-dom';
import FusionLogo from './FusionLogo';

// Shared sidebar lockup (Part A5) — identical shape across every Fusion
// product: the official Fusion F mark (mark-only /fusion-icon.svg, no
// baked-in wordmark) → "FUSION 2K" eyebrow (grey caps) → product name
// (lime, one shared type scale; "Supply Pilot" wraps to two lines) →
// one-line tagline (grey caps). No mascot in the header (A5) — product
// characters live in empty states + the user-chip avatar.
//
// Lime here is the sanctioned decorative use (logo/wordmark), not an
// outcome signal. Eyebrow + tagline stay muted so they support rather
// than compete with the product name.
export default function SidebarLogo() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/dashboard')}
      title="Supply Pilot — Fusion 2K"
      className="w-full pt-6 pb-5 px-2 xl:px-4 hover:bg-sb-hover focus:outline-none transition-colors flex flex-col items-center xl:items-start gap-3 flex-shrink-0 border-b border-sb-line">
      {/* Lockup stacks vertically (mark above the wordmark) to match the
          shared Fusion product sidebar — Quotezilla et al. */}
      <FusionLogo
        icon
        alt="Fusion"
        className="h-10 w-auto object-contain flex-shrink-0" />
      <span className="hidden xl:flex flex-col text-left leading-none">
        <span className="font-['Metropolis'] text-[9px] font-bold tracking-[0.22em] uppercase text-sb-muted mb-1">
          Fusion 2K
        </span>
        <span className="font-['Metropolis'] text-[20px] font-extrabold tracking-[0.04em] uppercase text-fusion-green leading-none">
          Supply Pilot
        </span>
        <span className="font-['Metropolis'] text-[9px] font-bold tracking-[0.18em] uppercase text-sb-section mt-1.5">
          Supplier Operations
        </span>
      </span>
    </button>
  );
}
